<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Appraisal Evaluation Parameter</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Sort Order</b></p>
            <v-text-field outlined dense type="number" v-model="sortorder"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Name</b></p>
            <v-text-field outlined dense type="text" v-model="name"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Max Marks</b></p>
            <v-text-field outlined dense type="number" v-model="maxmarks"></v-text-field>
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-checkbox v-model="islast" label="Is Last ?"></v-checkbox>
        </v-row>
        <v-row justify="center" dense v-if="ay && name && maxmarks">
          <v-btn color="warning" @click="saveEvaluationParameter()">Save</v-btn>
        </v-row>
      </v-card>

      <v-card class="box" v-if="filteredEvaluationParameterList != ''">
        <v-toolbar flat class="toolbar">
          <v-toolbar-title>Appraisal Credit List</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-data-table :headers="headers" :items="filteredEvaluationParameterList">
          <!-- <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Appraisal  Credit List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template> -->
          <template v-slot:top class="pb-5">
            <v-row justify="center" align="center">
              <tr class="t-row">
                <div>
                  <th>
                    <v-row>
                      <span v-for="header in headers" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                          <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                            color="#0F2027" :label="header.text" multiple clearable
                            :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                        </span>
                      </span>
                    </v-row>
                  </th>
                </div>
              </tr>
            </v-row>
          </template>

          <template v-slot:[`item.isactive`]="{ item }">
            <span v-if="item.isactive">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <template v-slot:[`item.islast`]="{ item }">
            <span v-if="item.islast">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-icon class="mr-2 v-icon-size" @click="editEvaluationParameter(item)" color="success">mdi-pencil</v-icon>
          </template>
          <template v-slot:[`item.toggle`]="{ item }">
            <v-switch v-model="item.isactive" @change="saveUpdateParameterIsctive(item)"></v-switch>
          </template>
        </v-data-table>
      </v-card>
      `<v-dialog v-model="dialog_edit" persistent scrollable="false" max-width="1200px"
        transition="dialog-bottom-transition">
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Appraisal Credit</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><b>Sort Order</b></p>
                <v-text-field type="number" outlined dense v-model="editedItem.sortorder"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Name</b></p>
                <v-text-field outlined dense v-model="editedItem.name"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Max Marks</b></p>
                <v-text-field type="number" outlined dense v-model="editedItem.maxmarks"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveeditEvaluationParameter()">Update</v-btn>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    criteria: "",
    ay_list: [],
    // extraBreadcrumbItems: [
    //   { text: "Evaluation Parameter", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    ay: "",
    maxmarks: "",
    name: "",
    sortorder: "",
    evaluation_parameter_list: [],
    dialog_edit: false,
    islast: false,
    headers: [
      { text: "Sr No", value: "count" },
      { text: "Sort Order", value: "sort_order" },
      { text: "Name", value: "name" },
      { text: "Max Marks", value: "maxmarks" },
      { text: "Academic Year", value: "academicyear" },
      { text: "Is Last?", value: "islast" },
      { text: "Active", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Mark Active/Inactive", value: "toggle" },
    ],
    editedItem: {
      id: "",
      name: "",
      maxmarks: "",
      sortorder: "",
    },
    filters: {
      academicyear: [],
    },
  }),
  methods: {
    columnValueList(val) {
      return this.evaluation_parameter_list.map((d) => d[val]);
    },
    saveUpdateParameterIsctive(item) {
      const data = {
        evaluation_parameter_id: item.id,
        isactive: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/SelfAppriasalMaster/saveUpdateParameterIsctive", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.evaluation_parameter_list = res.data.evaluation_parameter_list;
            this.showSnackbar("green", "Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    saveeditEvaluationParameter() {
      this.overlay = true;
      this.loader = true;
      axios
        .post(
          "/SelfAppriasalMaster/saveEditEvaluationParameter",
          this.editedItem
        )
        .then((res) => {
          if (res.data.flag == "YES") {
            this.evaluation_parameter_list = res.data.evaluation_parameter_list;
            this.dialog_edit = false;
            this.showSnackbar("green", "Details Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    editEvaluationParameter(item) {
      this.editedItem.id = item.id;
      this.editedItem.name = item.name;
      this.editedItem.maxmarks = item.maxmarks;
      this.editedItem.sortorder = item.sort_order;
      this.dialog_edit = true;
    },
    clearData() {
      this.name = "";
      this.maxmarks = "";
      this.sortorder = "";
      this.islast = false;
    },
    saveEvaluationParameter() {
      const data = {
        ay: this.ay,
        name: this.name,
        maxmarks: this.maxmarks,
        sortorder: this.sortorder,
        islast: this.islast,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/SelfAppriasalMaster/saveEvaluationParameter", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.evaluation_parameter_list = res.data.evaluation_parameter_list;
            this.clearData();
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          //this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    onLoad() {
      axios
        .post("SelfAppriasalMaster/evaluationParameter")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list),
              (this.evaluation_parameter_list =
                res.data.evaluation_parameter_list),
              (this.ay = res.data.current_ay);
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  computed: {
    bookList1() {
      return this.evaluation_parameter_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
    filteredEvaluationParameterList() {
        let filteredList = this.evaluation_parameter_list;
        if (this.ay) {
            filteredList = this.evaluation_parameter_list.filter(ay => ay.academicyear_id === Number(this.ay));
        }
        return filteredList; // ✅ RETURN the filtered list
    }
  },
  watch: {},
};
</script>
<style scoped>
</style>